import { useState, useEffect } from 'react';

interface RenameDialogProps {
  initialName: string;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

export default function RenameDialog({ initialName, onConfirm, onCancel }: RenameDialogProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleRename = () => {
    if (!name.trim()) return;
    onConfirm(name.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onCancel}>
      <div className="bg-background-50 rounded-xl p-6 max-w-sm w-full border border-background-200 animate-in fade-in zoom-in-95 duration-150" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-semibold text-foreground-900 mb-4">이름 바꾸기</h2>
        <input
          type="text" value={name} onChange={(e) => setName(e.target.value)}
          className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 text-foreground-800 placeholder-foreground-400 mb-4"
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter') handleRename(); }}
        />
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm font-medium rounded-lg border border-background-300 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">취소</button>
          <button onClick={handleRename} disabled={!name.trim()} className="px-4 py-2 text-sm font-medium rounded-lg bg-primary-500 text-white hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap">변경</button>
        </div>
      </div>
    </div>
  );
}